module.exports = __webpack_public_path__ + "static/media/no_trip.c0d35e62.png";